import { IdValue } from '../../shared/models';

export enum FeeWorksheetMilestone {
  InitialFeeSummary = -1,
  LoanPropertySection = 0,
  TaxQuestionSection = 1,
  TitleServiceSection = 2,
  SettlementServiceSection = 3,
  LandServiceSection = 4,
  PestServiceSection = 5,
  ClosingCostFinal = 6,
  FeeSummarySection = 7,
  ClosingCostCompleted = 9,
  StructuralEngineeringSection = 10,
}

export const CcwSectionName = {
  [FeeWorksheetMilestone.LoanPropertySection]: 'Loan and Property Information',
  [FeeWorksheetMilestone.TaxQuestionSection]: 'Closing Corp Questions',
  [FeeWorksheetMilestone.TitleServiceSection]: 'Closing Corp - Title Service Provider Details',
  [FeeWorksheetMilestone.SettlementServiceSection]: 'Closing Corp - Settlement Service Provider Details',
  [FeeWorksheetMilestone.LandServiceSection]: 'Closing Corp - Land Service Provider Details',
  [FeeWorksheetMilestone.PestServiceSection]: 'Closing Corp - Pest Service Provider Details',
  [FeeWorksheetMilestone.StructuralEngineeringSection]: 'Closing Corp - Engineering/Structural Inspections Services Provider Details',
  [FeeWorksheetMilestone.ClosingCostFinal]: 'Closing Cost Final',
  [FeeWorksheetMilestone.FeeSummarySection]: 'Fee Summary',
  [FeeWorksheetMilestone.ClosingCostCompleted]: 'ClosingCostCompleted',
};

export const GetCcwSectionName = (section: FeeWorksheetMilestone): string => {
  return CcwSectionName[section];
};

export enum MortgageType {
  Select = 0,
  Va = 1,
  Fha = 2,
  Conventional = 3,
  Usda = 4,
  Other = 5,
  Heloc = 6,
}

// NOTE: This mirrors the dropdown values as in Clear 1/does not contain everything shown on URLA.
export enum PurposeOfLoan {
  Select = 0,
  Purchase = 1,
  Refinance = 2,
  Second = 3,
  Third = 4,
  PurchaseMoneySecond = 5,
  PurchaseMoneyThird = 6,
  Other = 7,
}

export const purposeOfLoanOptions = [
  new IdValue(PurposeOfLoan.Select, PurposeOfLoan.Select, 'Select'),
  new IdValue(PurposeOfLoan.Purchase, PurposeOfLoan.Purchase, 'Purchase'),
  new IdValue(PurposeOfLoan.Refinance, PurposeOfLoan.Refinance, 'Refinance'),
  new IdValue(PurposeOfLoan.Second, PurposeOfLoan.Second, 'Second'),
  new IdValue(PurposeOfLoan.Third, PurposeOfLoan.Third, 'Third'),
  new IdValue(PurposeOfLoan.PurchaseMoneySecond, PurposeOfLoan.PurchaseMoneySecond, 'Purchase Money Second'),
  new IdValue(PurposeOfLoan.PurchaseMoneyThird, PurposeOfLoan.PurchaseMoneyThird, 'Purchase Money Third'),
  new IdValue(PurposeOfLoan.Other, PurposeOfLoan.Other, 'Other'),
];

export enum Lien {
  Select = 0,
  First = 1,
  Second = 2,
  Third = 3,
}

export const lienOptions = [
  new IdValue(Lien.Select, Lien.Select, 'Select'),
  new IdValue(Lien.First, Lien.First, 'First'),
  new IdValue(Lien.Second, Lien.Second, 'Second'),
  new IdValue(Lien.Third, Lien.Third, 'Third'),
];

export enum Escrow {
  Select = 0,
  WaiveAll = 1,
  NotWaived = 2,
  WaiveTaxesOnly = 3,
  WaiveInsuranceOnly = 4,
}

export enum OnTimeClosingGuarantee {
  Select = 0,
  Eligible = 1,
  Ineligible = 2,
}

export const onTimeClosingGuaranteeOptions = [
  new IdValue(OnTimeClosingGuarantee.Select, OnTimeClosingGuarantee.Select, 'Select'),
  new IdValue(OnTimeClosingGuarantee.Eligible, OnTimeClosingGuarantee.Eligible, 'Eligible'),
  new IdValue(OnTimeClosingGuarantee.Ineligible, OnTimeClosingGuarantee.Ineligible, 'Ineligible'),
];

export enum OccupancyType {
  Select = 0,
  PrimaryResidence = 1,
  SecondaryResidence = 2,
  InvestmentProperty = 3,
}

export const occupancyTypeOptions = [
  new IdValue(OccupancyType.Select, OccupancyType.Select, 'Select'),
  new IdValue(OccupancyType.PrimaryResidence, OccupancyType.PrimaryResidence, 'Primary Residence'),
  new IdValue(OccupancyType.SecondaryResidence, OccupancyType.SecondaryResidence, 'Secondary Residence'),
  new IdValue(OccupancyType.InvestmentProperty, OccupancyType.InvestmentProperty, 'Investment Property'),
];

export enum PropertyType {
  Select = 0,
  Detached = 1,
  Attached = 2,
  Condominium = 3,
  HighRiseCondo = 4,
  DetachedCondo = 5,
  PUD = 6,
  Cooperative = 7,
  Manufactured = 8,
  ManufacturedCondoPudCoOp = 9,
  ManufacturedSinglewide = 10,
  ManufacturedMultiwide = 11,
  Other = 12,
  ManufacturedMHAdvantage = 14,
}

export const structuralEngineeringPropertyTypes = [
  PropertyType.Manufactured,
  PropertyType.ManufacturedCondoPudCoOp,
  PropertyType.ManufacturedSinglewide,
  PropertyType.ManufacturedMultiwide,
  PropertyType.ManufacturedMHAdvantage,
];

export const propertyTypeOptions = [
  new IdValue(PropertyType.Select, PropertyType.Select, 'Select'),
  new IdValue(PropertyType.Detached, PropertyType.Detached, 'Detached'),
  new IdValue(PropertyType.Attached, PropertyType.Attached, 'Secondary Residence'),
  new IdValue(PropertyType.Condominium, PropertyType.Condominium, 'Condominium'),
  new IdValue(PropertyType.HighRiseCondo, PropertyType.HighRiseCondo, 'High Rise Condo'),
  new IdValue(PropertyType.DetachedCondo, PropertyType.DetachedCondo, 'Detached Condo'),
  new IdValue(PropertyType.PUD, PropertyType.PUD, 'PUD'),
  new IdValue(PropertyType.Cooperative, PropertyType.Cooperative, 'Cooperative'),
  new IdValue(PropertyType.Manufactured, PropertyType.Manufactured, 'Manufactured'),
  new IdValue(PropertyType.ManufacturedCondoPudCoOp, PropertyType.ManufacturedCondoPudCoOp, 'Manufactured Condo Pud Co-Op'),
  new IdValue(PropertyType.ManufacturedSinglewide, PropertyType.ManufacturedSinglewide, 'Manufactured Singlewide'),
  new IdValue(PropertyType.ManufacturedMultiwide, PropertyType.ManufacturedMultiwide, 'Manufactured Multiwide'),
  new IdValue(PropertyType.ManufacturedMHAdvantage, PropertyType.ManufacturedMHAdvantage, 'Manufactured MH Advantage'),
  new IdValue(PropertyType.Other, PropertyType.Other, 'Other'),
];

export enum SizeInAcres {
  ZeroToNine = '0',
  TenPlus = '1',
}

export const sizeInAcresOptions = [
  // No select option
  new IdValue(SizeInAcres.ZeroToNine, SizeInAcres.ZeroToNine, '0 to 9 acres'),
  new IdValue(SizeInAcres.TenPlus, SizeInAcres.TenPlus, '10+ acres'),
];

export enum AmcProviders {
  Select = 0,
  Ascribe = 1,
  AppraisalFirewall = 2,
  AppraisalLinks = 3,
  AppraisalValet = 4,
  ARIVS = 5,
  ClassAppraisalValuation = 6,
  ClickAppraiser = 7,
  DARTMaxVantage = 8,
  Eclipse = 9,
  EvaluationZoneInc = 10,
  GoldenState = 11,
  Incenter = 12,
  LendersChoice = 13,
  MLA = 14,
  Nationwide = 15,
  PropertyRate = 16,
  R3Review = 17,
  SobolAssociates = 18,
  ValueLink = 19,
  VAAppraisalRates = 20,
  PIWAppraisalFee = 21,
  EHSAppraisalManagement = 22,
  AppraisalMark = 23,
  GreatSouthBay = 24,
  Other = 999,
}

export const amcProvidersOptions = [
  new IdValue(AmcProviders.Select, AmcProviders.Select, 'Select'),
  new IdValue(AmcProviders.Ascribe, AmcProviders.Ascribe, 'Ascribe, LLC'),
  new IdValue(AmcProviders.AppraisalFirewall, AmcProviders.AppraisalFirewall, 'Appraisal Firewall'),
  new IdValue(AmcProviders.AppraisalLinks, AmcProviders.AppraisalLinks, 'Appraisal Links'),
  new IdValue(AmcProviders.AppraisalMark, AmcProviders.AppraisalMark, 'Appraisal Mark'),
  new IdValue(AmcProviders.AppraisalValet, AmcProviders.AppraisalValet, 'Appraisal Valet'),
  new IdValue(AmcProviders.ARIVS, AmcProviders.ARIVS, 'ARIVS'),
  new IdValue(AmcProviders.ClassAppraisalValuation, AmcProviders.ClassAppraisalValuation, 'Class Appraisal/Valuation'),
  new IdValue(AmcProviders.ClickAppraiser, AmcProviders.ClickAppraiser, 'Click Appraiser'),
  new IdValue(AmcProviders.DARTMaxVantage, AmcProviders.DARTMaxVantage, 'DART/MaxVantage AMC'),
  new IdValue(AmcProviders.Eclipse, AmcProviders.Eclipse, 'Eclipse'),
  new IdValue(AmcProviders.EHSAppraisalManagement, AmcProviders.EHSAppraisalManagement, 'EHS Appraisal Management'),
  new IdValue(AmcProviders.EvaluationZoneInc, AmcProviders.EvaluationZoneInc, 'eValuation Zone'),
  new IdValue(AmcProviders.GreatSouthBay, AmcProviders.GreatSouthBay, 'Great South Bay'),
  new IdValue(AmcProviders.GoldenState, AmcProviders.GoldenState, 'Golden State'),
  new IdValue(AmcProviders.LendersChoice, AmcProviders.LendersChoice, "Lender's Choice"),
  new IdValue(AmcProviders.MLA, AmcProviders.MLA, 'MLA'),
  new IdValue(AmcProviders.Nationwide, AmcProviders.Nationwide, 'Nationwide'),
  new IdValue(AmcProviders.PropertyRate, AmcProviders.PropertyRate, 'Property Rate'),
  new IdValue(AmcProviders.R3Review, AmcProviders.R3Review, 'R3 Review'),
  new IdValue(AmcProviders.SobolAssociates, AmcProviders.SobolAssociates, 'Sobol & Associates, Inc'),
  new IdValue(AmcProviders.ValueLink, AmcProviders.ValueLink, 'ValueLink'),
  new IdValue(AmcProviders.VAAppraisalRates, AmcProviders.VAAppraisalRates, 'VA Appraisal Rates'),
  new IdValue(AmcProviders.PIWAppraisalFee, AmcProviders.PIWAppraisalFee, 'PIW-No Appraisal Fee'),
];

export enum LoanPurposeType {
  Select = 0,
  Purchase = 1,
  Refinance = 2,
  Construction = 3,
  ConstructionPerm = 4,
  Second = 5,
  Third = 6,
  PurchaseMoneySecond = 7,
  Other = 8,
  PurchaseMoneyThird = 9,
}

export enum RefinancePurpose {
  None = 0,
  CashOutDebtConsolidation = 1,
  CashOutHomeImprovement = 2,
  CashOutLimited = 3,
  CashOutOther = 4,
  NoCashOutFHAStreamlinedRefinance = 5,
  NoCashOutFREOwnedRefinance = 6,
  NoCashOutOther = 7,
  NoCashOutStreamlinedRefinance = 8,
  ChangeInRateTerm = 9,
}

export const refinancePurposeOptionsGeneral = [
  new IdValue(RefinancePurpose.None, RefinancePurpose.None, 'Select'),
  new IdValue(RefinancePurpose.CashOutDebtConsolidation, RefinancePurpose.CashOutDebtConsolidation, 'Cash-Out Debt Consolidation'),
  new IdValue(RefinancePurpose.CashOutHomeImprovement, RefinancePurpose.CashOutHomeImprovement, 'Cash-Out Home Improvement'),
  new IdValue(RefinancePurpose.CashOutLimited, RefinancePurpose.CashOutLimited, 'Limited Cash Out'),
  new IdValue(RefinancePurpose.CashOutOther, RefinancePurpose.CashOutOther, 'Cash-Out Other'),
  new IdValue(
    RefinancePurpose.NoCashOutFHAStreamlinedRefinance,
    RefinancePurpose.NoCashOutFHAStreamlinedRefinance,
    'No Cash-Out/FHA Streamlined Refinance',
  ),
  new IdValue(RefinancePurpose.NoCashOutFREOwnedRefinance, RefinancePurpose.NoCashOutFREOwnedRefinance, 'No Cash-Out/FRE Owned Refinance'),
  new IdValue(RefinancePurpose.NoCashOutOther, RefinancePurpose.NoCashOutOther, 'No Cash-Out Other'),
  new IdValue(RefinancePurpose.NoCashOutStreamlinedRefinance, RefinancePurpose.NoCashOutStreamlinedRefinance, 'No Cash-Out Streamlined Refinance'),
  new IdValue(RefinancePurpose.ChangeInRateTerm, RefinancePurpose.ChangeInRateTerm, 'Change in Rate/Term'),
];

export const refinancePurposeOptionsVa = [new IdValue(0, 0, 'Select'), new IdValue(1, 1, 'IRRRL'), new IdValue(2, 2, 'Other')];

export const refinancePurposeOptionsFha = [
  new IdValue(0, 0, 'Select'),
  { ...new IdValue(1, 1, 'Streamlined With Appraisal'), isHidden: true },
  new IdValue(2, 2, 'Streamlined without Appraisal'),
  new IdValue(3, 3, 'No Cash Out'),
  new IdValue(4, 4, 'Cash Out'),
];

export enum ResponsiblePartyType {
  Buyer = 0,
  Seller = 1,
}

export enum FeeWorkSheetRequestType {
  Select = 0,
  OptionChange = 1,
  CalculateOnly = 2,
  Save = 3,
  SaveInfoOnly = 4,
}

export enum FundingFeeType {
  select = 0,
  regularMilitaryFirstUse = 1,
  regularMilitarySubsequentUse = 2,
  reservesOrGuardFirstUse = 3,
  reservesOrGuardSubsequentUse = 4,
  interestRateReductionRefi = 5,
  manufacturedHome = 6,
  loanAssumption = 7,
  exempt = 8,
}

export const fundingFeeTypeOptions = [
  new IdValue(FundingFeeType.select, FundingFeeType.select, 'Select'),
  new IdValue(FundingFeeType.regularMilitaryFirstUse, FundingFeeType.regularMilitaryFirstUse, 'Regular Military First Use'),
  new IdValue(FundingFeeType.regularMilitarySubsequentUse, FundingFeeType.regularMilitarySubsequentUse, 'Regular Military Subsequent Use'),
  new IdValue(FundingFeeType.reservesOrGuardFirstUse, FundingFeeType.reservesOrGuardFirstUse, 'Reserves or Guard First Use'),
  new IdValue(FundingFeeType.reservesOrGuardSubsequentUse, FundingFeeType.reservesOrGuardSubsequentUse, 'Reserves or Guard Subsequent Use'),
  new IdValue(FundingFeeType.interestRateReductionRefi, FundingFeeType.interestRateReductionRefi, 'Interest Rate Reduction Refi'),
  new IdValue(FundingFeeType.manufacturedHome, FundingFeeType.manufacturedHome, 'Manufactured Home'),
  new IdValue(FundingFeeType.loanAssumption, FundingFeeType.loanAssumption, 'Loan Assumption'),
  new IdValue(FundingFeeType.exempt, FundingFeeType.exempt, 'Exempt'),
];

export enum PmiType {
  Monthly = 0,
  None = 1,
  LevelAnnual = 2,
  StandardAnnual = 3,
  SinglePremiumRefund = 4,
  SinglePremiumLimitedRefund = 5,
  LenderPaid = 7,
  SplitPremium = 8,
  QMSinglePremium = 9,
  QMSplitPremium = 10,
  QMStandardAnnual = 11,
}

export enum FeesheetReportType {
  ClearFeesheetReport = 1,
  ByteFeesheetReport = 2,
  ByteFeesheetReport2 = 3,
  AIOPreApplicationFeeEstimateWorksheet = 4,
}

export enum Confirm {
  NotAssigned = 0,
  Yes = 1,
  No = 2,
}

export enum ServiceProviderWorkflow {
  SpecificProviders = 'Select Specific Providers',
  CMGDefaultProviders = 'Use Default Providers',
}

export const serviceControlIds = [
  { key: FeeWorksheetMilestone.LandServiceSection, id: 'landServiceControlId' },
  { key: FeeWorksheetMilestone.TitleServiceSection, id: 'titleServiceControlId' },
  { key: FeeWorksheetMilestone.SettlementServiceSection, id: 'settlementServiceControlId' },
  { key: FeeWorksheetMilestone.PestServiceSection, id: 'pestServiceControlId' },
  { key: FeeWorksheetMilestone.StructuralEngineeringSection, id: 'structuralEngineeringServiceControlId' },
];

export const landSurveyStates = ['FL', 'NM', 'TX'];

export enum FeeNames {
  SurveyFee = 'Survey Fee',
  PestFee = 'Pest Inspection',
  EngineeringFee = 'Engineer Cert Fee',
}

export enum PrepaidItemType {
  Hazard = 1,
  MortgageInsurance = 2,
  Line7 = 3,
  PropertyTax = 4,
  AssociationDues = 5,
  Flood = 6,
  Line8 = 7,
}
